// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UAYW","label":"styles_label__1ro0Y"};